import { ServerRoutes } from "@rinastyling/common";
import {
  AddItemToCart,
  CheckCouponCodeValidty,
  GetCourseCreditCardPage,
  GetPopupStoreCartCreditCardPage,
  GetStylingCreditCardPage,
  GetWorkshopCreditCardPage,
  RemoveItemFromCart,
  WorkshopUpdateOrderUsed
} from "@rinastyling/common";
import { ServerService } from "./ServerService";
export class BuyingShitService extends ServerService {
  constructor() {
    super(ServerRoutes.buyingShit);
  }
  getCourseCreditCardPage(
    params: GetCourseCreditCardPage["params"],
    query: GetCourseCreditCardPage["query"]
  ) {
    return this.typedFetch<null, GetCourseCreditCardPage["response"]>(
      `course/${params.courseId}`,
      { method: "GET" },
      query?.couponCodeHash ? (query as Record<string, string>) : undefined
    );
  }
  checkCouponCodeValidty(body: CheckCouponCodeValidty["request"]) {
    return this.typedFetch<
      CheckCouponCodeValidty["request"],
      CheckCouponCodeValidty["response"]
    >("check-coupon-code", { body, method: "POST" });
  }
  AddItemToCart(body: AddItemToCart["request"]) {
    return this.typedFetch<AddItemToCart["request"], AddItemToCart["response"]>(
      "add-item-to-cart",
      { body, method: "POST" }
    );
  }
  removeItemFromCart(query: RemoveItemFromCart["query"]) {
    return this.typedFetch<
      RemoveItemFromCart["request"],
      RemoveItemFromCart["response"]
    >("remove-item-from-cart", { method: "DELETE" }, query);
  }
  getStylingCreditCardPage(params: GetStylingCreditCardPage["params"]) {
    return this.typedFetch<
      GetStylingCreditCardPage["request"],
      GetStylingCreditCardPage["response"]
    >(`styling/${params.stylingDateId}`);
  }
  getPopupStoreCartCreditCardPage(
    query: GetPopupStoreCartCreditCardPage["query"]
  ) {
    return this.typedFetch<
      GetPopupStoreCartCreditCardPage["request"],
      GetPopupStoreCartCreditCardPage["response"]
    >(`popup-store-cart-credit-card-page`, { method: "GET" }, query);
  }

  getWorkshopCreditCardPage(query: GetWorkshopCreditCardPage["query"]) {
    return this.typedFetch<
      GetWorkshopCreditCardPage["request"],
      GetWorkshopCreditCardPage["response"]
    >(`get-workshop-credit-card`, { method: "GET" }, query);
  }
  workshopUpdateOrderUsed(body: WorkshopUpdateOrderUsed["request"]) {
    return this.typedFetch<
      WorkshopUpdateOrderUsed["request"],
      WorkshopUpdateOrderUsed["response"]
    >(`workshop-update-order-used`, { body, method: "PUT" });
  }
}
